import React, { useRef, useEffect } from 'react';
import { RatingIcon as HalfStarIcon, StarFullIcon, StarBlankIcon } from "../Icon";
const reRate = (num) => {
    if (Number.isInteger(num))
        return num;
    const rest = num - Math.floor(num);
    const integer = num - rest;
    if (rest < 0.25)
        return integer;
    if (rest > 0.75)
        return integer + 1;
    return integer + 0.5;
};
const getIcon = (type, id, iconSize) => {
    switch (type.toLowerCase()) {
        case 'filled':
            return React.createElement(StarFullIcon, { key: id, size: iconSize });
        case 'half':
            return React.createElement(HalfStarIcon, { key: id, size: iconSize });
        case 'empty':
            return React.createElement(StarBlankIcon, { key: id, size: iconSize });
        default:
            return null;
    }
};
const RatingStars = ({ className, rating, max = 5, iconSize = 'small', handleRatingStarOnClick, }) => {
    const starMapped = reRate(rating);
    const filled = Math.floor(starMapped);
    const half = !Number.isInteger(starMapped);
    const starsContainerRef = useRef(null);
    const handleClickOnStars = (e) => {
        var _a, _b;
        const index = [...(_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.children].indexOf(e.target);
        if (handleRatingStarOnClick)
            handleRatingStarOnClick(index + 1);
    };
    useEffect(() => {
        var _a;
        if (starsContainerRef) {
            (_a = starsContainerRef === null || starsContainerRef === void 0 ? void 0 : starsContainerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', handleClickOnStars);
        }
        return () => {
            var _a;
            (_a = starsContainerRef === null || starsContainerRef === void 0 ? void 0 : starsContainerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', handleClickOnStars);
        };
    }, []);
    const elements = [];
    for (let i = 0; i < max; i += 1) {
        if (half) {
            if (i < filled)
                elements.push(getIcon('filled', `icon${i}`, iconSize));
            else if (i === filled)
                elements.push(getIcon('half', `icon${i}`, iconSize));
            else
                elements.push(getIcon('empty', `icon${i}`, iconSize));
        }
        else if (i < filled)
            elements.push(getIcon('filled', `icon${i}`, iconSize));
        else
            elements.push(getIcon('empty', `icon${i}`, iconSize));
    }
    return (React.createElement("span", { role: "img", className: className, "aria-label": `${rating} / ${max}` }, handleRatingStarOnClick ? React.createElement("div", { ref: starsContainerRef }, elements) : elements));
};
export default RatingStars;
//# sourceMappingURL=RatingStars.js.map